import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const ORG_PERMISSIONS = {
  READ: PERMISSIONS.ORGS_READ,
  WRITE: PERMISSIONS.ORGS_WRITE,
  APPROVE: PERMISSIONS.ORG_APPROVE,
};

export const ORG_QUERY_KEYS = queryKeys.organizations;

export const ORG_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
};

export const ORG_TYPE = {
  BUYER: 'BUYER',
  SUPPLIER: 'SUPPLIER',
};
